
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ImagePaths } from '@/lib/imageUrls';

const Navbar = React.memo(() => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Services',
    path: '/services'
  }, {
    name: 'Training',
    path: '/training'
  }, {
    name: 'Pathways',
    path: '/pathways'
  }, {
    name: 'Assessments',
    path: '/assessments'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'Resources',
    path: '/resources'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  
  const isActive = path => location.pathname === path;
  
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center shrink-0">
            <Link to="/" className="flex items-center gap-2.5" aria-label="Educ4te home">
              <img
                src="/images/logos/lion-mark.svg"
                alt=""
                className="h-9 md:h-11 w-auto"
                width="40"
                height="50"
                loading="eager"
                fetchpriority="high"
                decoding="sync"
              />
              <span className="text-xl md:text-2xl font-black text-[#422680] tracking-tight leading-none">
                EDUC<span className="text-[#F54952]">4</span>TE
              </span>
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-[#422680] ${isActive(link.path) ? 'text-[#422680]' : 'text-gray-700'}`}>
                {link.name}
              </Link>)}
            <Link to="/training">
              <Button className="bg-[#F54952] hover:bg-[#660F56] text-white transition-colors">
                Get Started
              </Button>
            </Link>
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-gray-700 p-2" aria-label="Toggle menu">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden">
            <div className="px-4 py-4 space-y-3">
              {navLinks.map(link => <Link key={link.name} to={link.path} onClick={() => setIsOpen(false)} className={`block w-full text-left font-medium py-2 ${isActive(link.path) ? 'text-[#422680]' : 'text-gray-700'}`}>
                  {link.name}
                </Link>)}
              <Link to="/training" onClick={() => setIsOpen(false)}>
                <Button className="w-full bg-[#F54952] hover:bg-[#660F56] text-white transition-colors mt-2">
                  Get Started
                </Button>
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
});

Navbar.displayName = 'Navbar';
export default Navbar;
